import { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import { signInWithRedirect } from 'aws-amplify/auth';
import { getConfig } from '../config';
import Grid from '@mui/material/Grid';
import { logger } from '../utilities/logger';
import { useAppStateContext } from '../providers/AppStateProvider';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../providers/AuthProvider';
import { CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';

export const Login = () => {
  const log = logger();
  const { t } = useTranslation();

  const config = getConfig();

  // Component State
  const [loading, setLoading] = useState(false);

  // Component Context
  const { setSnackbar } = useAppStateContext();
  const { authStatus } = useAuthContext();

  const login = async () => {
    try {
      setLoading(true);
      await signInWithRedirect({
        provider: { custom: config.COGNITO_SAML_IDP_NAME },
      });
    } catch (error) {
      log.error('Error signing in: ', error);
      setSnackbar({
        message: t('snackbarLoginError'),
        timeout: 5000,
        open: true,
        severity: 'warning',
      });
      setLoading(false);
    }
  };

  return (
    <>
      {authStatus === 'authenticated' ? (
        <Navigate to='/' replace />
      ) : (
        <Grid
          container
          direction='column'
          justifyContent='center'
          alignItems='center'
          flexGrow={1}
          height={'100%'}
        >
          <Grid item>
            {authStatus === 'configuring' ? (
              <CircularProgress />
            ) : (
              <LoadingButton
                onClick={() => login()}
                variant='contained'
                loading={loading}
                size={'large'}
              >
                {t('loginWithSso')}
              </LoadingButton>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
};
